<template>
  <div class="row">
    <div class="col">
      <div class="card">
        <!-- Card header -->
        <card-header :title="$router.currentRoute.meta.title" />
        <!-- Card body -->
        <form role="form" @submit.prevent="update">
          <div class="card-body">
            <div class="row">
              <div class="col-6">
                <div v-if="serverError" class="alert alert-danger">
                  <strong>{{ $t('labels.error') }} : </strong> {{ serverError }}
                </div>
              </div>
            </div>
            <div class="row" v-if="isItemFound()">
              <input-text v-model="title" :options="{ id: 'title', label: 'title', error: fieldErrors.title }"/>
              <input-textarea v-model="description" :options="{ id: 'description', label: 'description', error: fieldErrors.description, containerClass: 'col-12' }"/>
            </div>
            <div class="row" v-if="isItemFound()">
              <input-checkbox v-model="enabled" :options="{ id: 'enabled', label: 'enabled', error: fieldErrors.enabled }"/>
            </div>
          </div>
          <!-- Card footer -->
          <div class="card-footer">
            <div class="row">
              <div class="col text-right">
                <router-link :to="{ name: `${routePrefix}.index`}"  class="btn btn-neutral btn-sm">
                  <i class="fa fa-arrow-left"></i>
                </router-link>
                <button v-if="isItemFound()" type="submit" class="btn btn-primary btn-sm" :disabled="loading">
                  <span v-if="loading" class="spinner-border spinner-border-sm"></span>
                  <i class="fa fa-save"></i>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
  import { TICKETS_ROOTS_TYPES_SHOW as CRUD_ACTION_SHOW,TICKETS_ROOTS_TYPES_UPDATE as CRUD_ACTION_UPDATE } from 'actions/tickets';
  const TICKETS_CODE="tickets";
  const TICKETS_ROOTS_CODE=`${TICKETS_CODE}.roots`;
  const CRUD_CODE=`${TICKETS_ROOTS_CODE}.types`;
  export default {
    name: "TicketRootTypeEdit",
    data(){
      return {
        routePrefix: CRUD_CODE,
        transPrefix: CRUD_CODE,
        ticketsRoutePrefix: TICKETS_CODE,
        ticketsTransPrefix: TICKETS_CODE,
        ticketRootsRoutePrefix: TICKETS_ROOTS_CODE,
        ticketRootsTransPrefix: TICKETS_ROOTS_CODE,
        id:this.$router.currentRoute.params.id,
        type_id:this.$router.currentRoute.params.type_id,
        title: '',
        description: '',
        enabled: false,
        serverError: '',
        fieldErrors: {},
        responseStatus:'',
        formMode: 'edit',
        loading: false,
      }
    },
    mounted() {
      this.getItem();
    },
    methods: {
      isItemFound(){
        return this.responseStatus!==404;
      },
      getItem(){
        this.$store.dispatch(CRUD_ACTION_SHOW,{
          ticketId: this.id,
          id: this.type_id,
        }).then(response=>{
          this.title=response.data.title;
          this.description=response.data.description;
          this.enabled=response.data.enabled;
        }).catch(error => {
          this.loading = false;
          this.serverError='';

          if(error.response){
            let responseData=error.response.data;

            if(responseData.errors){
              this.fieldErrors=responseData.errors;
            }else{
              this.serverError = 'Invalid Request.'
            }
          }else{
            this.serverError = this.$i18n.t("messages.no_internet_connection");
          }

          if(this.fieldErrors.error){
            this.serverError = this.fieldErrors.error;
          }
        });
      },
      prepareRequestData(){
        return {
          title: this.sanitizeField('title'),
          description: this.sanitizeField('description'),
          enabled: this.sanitizeField('enabled'),
        }
      },
      update() {
        this.loading = true;
        this.$store.dispatch(CRUD_ACTION_UPDATE, {
          id: this.type_id,
          ticketId: this.id,
          data: {
            ...this.prepareRequestData()
          },
        })
        .then(() => {
          swal({
            icon: 'success',
            text: this.$i18n.t("messages.update_successfully"),
            buttons:false,
            timer: 5000
          });
          this.$router.push({ name: `${this.routePrefix}.index` })
        })
        .catch(error => {
          this.loading = false;
          this.fieldErrors={};
          this.serverError='';

          if(error.response){
            this.responseStatus=error.response.status;
            let responseData=error.response.data;

            if(responseData.errors){
              this.fieldErrors=responseData.errors;
            }else{
              this.serverError = 'Invalid Request.'
            }
          }else{
            this.serverError = this.$i18n.t("messages.no_internet_connection");
          }

          if(this.fieldErrors.error){
            this.serverError = this.fieldErrors.error;
          }
        })
      }
    },
  };
</script>
